import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chargingSessionReport: [],
  totalCount: 0,
  loading: false,
  error: null,
};

const GetAllChargingSessionReducer = createSlice({
  name: "getAllChargingSession",
  initialState,
  reducers: {
    fetchChargingSessionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchChargingSessionSuccess: (state, action) => {
      state.loading = false;
      state.chargingSessionReport =
        action.payload?.data?.ChargingSessionReport?.records || [];
      state.totalCount =
        action.payload?.data?.ChargingSessionReport?.totalCount || 0;
    },

    fetchChargingSessionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchChargingSessionRequest,
  fetchChargingSessionSuccess,
  fetchChargingSessionFailure,
} = GetAllChargingSessionReducer.actions;

export default GetAllChargingSessionReducer.reducer;